(() => {
  const initialize = () => {
    document.querySelectorAll('.be-top-intro:not(.is-enhanced)').forEach(intro => {
      const button = intro.querySelector('.be-top-intro__toggle');
      const panel = intro.querySelector('.be-top-intro__panel');
      if (!button || !panel) return;
      const mobile = window.matchMedia('(max-width: 600px)');
      let expanded = false;
      const update = () => {
        intro.classList.toggle('is-expanded', expanded);
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = expanded ? '－　閉じる' : '＋　サロン専売品とは';
        panel.setAttribute('aria-hidden', String(mobile.matches && !expanded));
        panel.inert = mobile.matches && !expanded;
      };
      button.addEventListener('click', () => { expanded = !expanded; update(); });
      mobile.addEventListener('change', update);
      update();
      intro.classList.add('is-enhanced');
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
